(function(){
  const scriptTag = document.currentScript;
  const sectionId = scriptTag && scriptTag.dataset.sectionId;
  if (!sectionId) return;

  function onReady() {
    console.log('✅ Upsell loaded for section', sectionId);

    // — find our section wrapper —
    const wrapper = document.querySelector(`[data-section="${sectionId}"]`);
    if (!wrapper) return console.error('Upsell: section wrapper missing');

    // — grab the Shopify form by its ID —
    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form) return console.error('Upsell: form#product-form-' + sectionId + ' not found');

    // — grab price + toggle UI —
    const priceContainer = wrapper.querySelector(`#price-${sectionId}`);
    const upsellPriceEl  = wrapper.querySelector('.cy-add-to-order__price');
    const toggle         = wrapper.querySelector(`#cy-toggle-${sectionId}`);
    if (!priceContainer || !upsellPriceEl || !toggle) {
      return console.error('Upsell: UI elements missing', { priceContainer, upsellPriceEl, toggle });
    }

    // — helpers to recalc price —
    const parseMoney = s => parseFloat(s.replace(/[^0-9.]/g,'')) || 0;
    const getPriceEl = () =>
      priceContainer.querySelector('.price-item--sale') ||
      priceContainer.querySelector('.price-item--regular') ||
      priceContainer.querySelector('.price-item');

    let origHTML, origVal;
    function cacheOriginal() {
      const el = getPriceEl();
      origHTML = el.innerHTML;
      origVal  = parseMoney(el.textContent);
    }
    function renderPrice() {
      const el = getPriceEl();
      if (toggle.checked) {
        const up    = parseMoney(upsellPriceEl.textContent);
        const total = (origVal + up).toFixed(2);
        const parts = el.textContent.trim().match(/^(\D*)([\d.,]+)(.*)$/) || [];
        el.textContent = `${parts[1]||''}${total}${parts[3]||''}`;
      } else {
        el.innerHTML = origHTML;
      }
    }

    // — update price on variant change & toggle —
    document.body.addEventListener('change', e => {
      if (e.target.name === 'id') {
        toggle.checked = false;
        cacheOriginal(); renderPrice();
      }
    });
    toggle.addEventListener('change', renderPrice);

    // — intercept the add-to-cart submission —
    form.addEventListener('submit', evt => {
      evt.preventDefault();
      const data   = new FormData(form);
      const mainId = data.get('id');
      const qty    = parseInt(data.get('quantity'),10) || 1;
      console.log('Upsell submit, mainId=', mainId, 'qty=', qty, 'upsell=', toggle.checked);

      const addItems = items =>
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type':'application/json' },
          body: JSON.stringify({ items })
        }).then(r => r.ok ? r.json() : Promise.reject(r));

      if (toggle.checked) {
        addItems([{ id: toggle.value, quantity: 1 }])
          .then(() => addItems([{ id: mainId, quantity: qty }]))
          .then(() => window.location = '/cart')
          .catch(err => console.error('[Upsell] error', err));
      } else {
        addItems([{ id: mainId, quantity: qty }])
          .then(() => window.location = '/cart')
          .catch(err => console.error('[Upsell] error', err));
      }
    });

    // — initialize price tweak —
    cacheOriginal(); renderPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
